module.exports = __webpack_public_path__ + "static/media/error_card.3ddc5251.svg";